import React, { useEffect, useState } from 'react';
import logo from '../../assets/images/dt_logo_white.png';
import './footer.css';

import {linksConfig} from "../../linksConfig";

async function loadFooterData(setFooterData,accessToken){
  try {
   if(accessToken ===''){console.log('access token not obtained!')}
    var headers = new Headers();
    var bearer = "Bearer "+accessToken;
    headers.append("Authorization",bearer);
    var options={method:"GET",headers:headers};
    await fetch(`${linksConfig.link.apilink}/footer`,options)
    .then(response => response.json())
    .then(receiveData =>setFooterData(receiveData))
   }
  catch(error){
    console.log(error)
   return('error');
   }

  }


const Footer = (Props) => {

  const [footerData,setFooterData] = useState(['']);
  useEffect(()=>{
    if(footerData ==''){
      loadFooterData(setFooterData,Props.accessToken);
    // console.log(Props.accessToken)
    }
    
  },[footerData,Props.accessToken])

  return(
  <div className="secnav__footer section__padding">
    
    <div className="secnav__footer-links">
      <div className="secnav__footer-links_logo">
        <img src={logo} alt="secnav_logo" />
        <p>Leinfelden-Echterdingen, Germany.</p>
      </div>
 
      <div className="secnav__footer-links_div">
        <h4>Provide Feedbacks</h4>
        <p>For any feedback related to content,</p>
        <p>please write to <a href={'mailto:' + footerData[0]['email']}><u>Secnav Feedback</u></a></p>
      </div>
    </div>

  </div>
  );
};

export default Footer;
